import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { showLogoutModal } from 'redux/navigation'
import { Icon, Menu } from 'semantic-ui-react'
import LogoutModal from './LogoutModal'

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    showLogoutModal: () => {
      dispatch(showLogoutModal())
    },
  }
}

class LogoutButton extends React.Component {
  render() {
    const { showLogoutModal } = this.props
    return (
      <Menu.Item onClick={showLogoutModal}>
        <Icon name="unlock" size="large" />
        <span className="hide-below-tablet">{I18n.t('logout.title')}</span>
        <LogoutModal />
      </Menu.Item>
    )
  }
}

LogoutButton = connect(mapStateToProps, mapDispatchToProps)(LogoutButton)
export default LogoutButton



// WEBPACK FOOTER //
// ./src/components/shared/Logout/LogoutButton.jsx